import React from "react";
import getClassNameFactory from "../../../../utilities/classNames";
import { Avatar } from "../../../../";
import { ImageSizes } from "../../../../elements/Image/ImageTypes";

var Profile = function Profile(_ref) {
  var href = _ref.href,
      location = _ref.location,
      name = _ref.name,
      title = _ref.title,
      imgSrc = _ref.imgSrc,
      imgSrcSet = _ref.imgSrcSet;
  var getClassName = getClassNameFactory("ProfileGallery");
  var NameElement = href ? "a" : "div";
  var nameProps = {
    className: getClassName({
      descendantName: "profileName"
    })
  };

  if (href) {
    nameProps.href = href;
  }

  return /*#__PURE__*/React.createElement("li", {
    className: getClassName({
      descendantName: "profile"
    })
  }, /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "profileHeadshot"
    })
  }, /*#__PURE__*/React.createElement(Avatar, {
    alt: "",
    sizes: ImageSizes.PROFILE,
    src: imgSrc,
    srcSet: imgSrcSet
  })), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "profileInner"
    })
  }, /*#__PURE__*/React.createElement(NameElement, nameProps, name), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "profileTitle"
    })
  }, title), /*#__PURE__*/React.createElement("div", {
    className: getClassName({
      descendantName: "profileLocation"
    })
  }, location)));
};

Profile.displayName = "ProfileGallery.Item";
export default Profile;